module.exports = __webpack_public_path__ + "static/media/ecosystem-user.86136bb5.svg";